import type { ClientSubIB } from "../../../api/generated";

import { User02Icon } from "../../../Icons";
import { Typo } from "../../../Typo";
import { useRebateProgramCellTranslate } from "./useRebateProgramCellTranslate";

export type MobileRebateProgramValueProps = {
  hasOfferID: string | null;
  subIBs?: ClientSubIB[] | null;
  onSharedProgramClick?: (hasOfferID: string) => void;
};

export const MobileRebateProgramValue = ({
  hasOfferID,
  subIBs,
  onSharedProgramClick,
}: MobileRebateProgramValueProps) => {
  const translations = useRebateProgramCellTranslate();

  if (!hasOfferID) return "-";

  if (!subIBs?.length || !onSharedProgramClick) {
    return translations.hoid(hasOfferID);
  }

  return (
    <button
      type="button"
      onClick={() => onSharedProgramClick(hasOfferID)}
      data-testid={`client_trading_mobile_card_rebate_program_${hasOfferID}_button`}
      className="flex w-full min-w-0 flex-col items-end gap-1 text-end"
    >
      <Typo element="span" type="bodyXS" className="underline">
        {translations.hoid(hasOfferID)}
      </Typo>
      <span className="flex w-full min-w-0 items-start justify-end gap-1">
        <User02Icon className="size-4 shrink-0" aria-hidden />
        <Typo
          element="span"
          type="bodyXS"
          textColor="text-text-secondary"
          className="min-w-0 truncate"
        >
          {subIBs.map((subIB) => subIB.name).join(", ")}
        </Typo>
      </span>
    </button>
  );
};
